import {createFileRoute} from '@tanstack/react-router';
import GlobalDiagnosticReports from '@/patient/views/GlobalDiagnosticReports';

export const Route = createFileRoute('/(patient)/global-diagnostic-reports')({
  component: GlobalDiagnosticReports
});
